import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as translations from './intl';
import { useTranslation } from '../../../../shared/hooks';
import {
  TermsAndConditions,
  PrivacyPolicy,
  Button,
} from '../../../../components';

const getStyles = (theme) => ({
  container: {
    height: '8em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1em 5em',
    background: theme.palette.primary.footerbackgroundcolor,
    color: theme.palette.text.main,
  },
  termButton: {
    overflowWrap: 'break-word',
    width: '16em',
    fontFamily: 'Source Sans Pro !important',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '18px',
    letterSpacing: '1px',
    textAlign: 'center',
    minWidth: '250px',
    textTransform: 'uppercase',
    '&, &:hover': {
      color: '#fff !important',
      borderColor: '#fff !important',
    },
  },
});

export default function TermsAndPolicySession() {
  const theme = useTheme();
  const classes = getStyles(theme);
  const { locale: intl } = useTranslation({
    translationsFile: translations,
  });
  const { USER_TERMS, PRIVACY } = intl;
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const handleToggleTerms = () => {
    setShowTerms((prevShowTerms) => !prevShowTerms);
    if (!showTerms) {
      window.dataLayer.push({
        zone: 'homepage',
        element_clicked: 'user terms and policy',
        event: 'navigation',
      });
    }
  };

  const handleTogglePrivacy = () => {
    setShowPrivacy((prevShowPrivacy) => !prevShowPrivacy);
    if (!showPrivacy) {
      window.dataLayer.push({
        zone: 'homepage',
        element_clicked: 'privacy policy',
        event: 'navigation',
      });
    }
  };

  return (
    <>
      <TermsAndConditions
        showTerms={showTerms}
        handleShowTerms={handleToggleTerms}
      />
      <PrivacyPolicy
        showPrivacy={showPrivacy}
        handleShowPrivacy={handleTogglePrivacy}
      />
      <Box sx={classes.container} data-testid="terms-policy">
        <Grid container alignItems="center" justifyContent="center" spacing={2}>
          <Grid size={{ xs: 'auto' }}>
            <Button
              sx={classes.termButton}
              text={USER_TERMS}
              variant="outlined"
              onClick={handleToggleTerms}
            />
          </Grid>
          <Grid size={{ xs: 'auto' }}>
            <Button
              sx={classes.termButton}
              text={PRIVACY}
              variant="outlined"
              onClick={handleTogglePrivacy}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
